import { NavLink, Navigate, Route, Routes } from "react-router-dom";
import {
  AuthenticatedTemplate, UnauthenticatedTemplate, useMsal,
} from "@azure/msal-react";
import { loginRequest } from "./authConfig";
import { useRoles } from "./hooks";
import Dashboard from "./pages/Dashboard";
import Executive from "./pages/Executive";
import Locations from "./pages/Locations";
import Upload from "./pages/Upload";
import Employee from "./pages/Employee";
import EmployeeProfile from "./pages/EmployeeProfile";
import Rankings from "./pages/Rankings";
import Reports from "./pages/Reports";
import Administration from "./pages/Administration";
import AttendancePolicies from "./pages/AttendancePolicies";

function SignIn() {
  const { instance } = useMsal();
  return (
    <div className="center">
      <div>
        <h1 className="h1">AccessIQ</h1>
        <p className="sub">Sign in with your organizational account.</p>
        <button className="primary" onClick={() => instance.loginRedirect(loginRequest)}>
          Sign in with Microsoft
        </button>
      </div>
    </div>
  );
}

function AdminRoute({ children }: { children: JSX.Element }) {
  const { isAdmin } = useRoles();
  return isAdmin ? children : <Navigate to="/" replace />;
}

function Shell() {
  const { instance } = useMsal();
  const { isAdmin, name, username } = useRoles();
  const link = ({ isActive }: { isActive: boolean }) => "navlink" + (isActive ? " active" : "");
  return (
    <div className="app">
      <aside className="sidebar">
        <div className="brand">AccessIQ<small>Access Analytics</small></div>
        <NavLink to="/" end className={link}>Dashboard</NavLink>
        <NavLink to="/executive" className={link}>Executive</NavLink>
        <NavLink to="/employees" end className={link}>Employee Attendance</NavLink>
        <NavLink to="/rankings" className={link}>Rankings</NavLink>
        <NavLink to="/locations" className={link}>Locations</NavLink>
        <NavLink to="/reports" className={link}>Reports</NavLink>
        {isAdmin && <NavLink to="/upload" className={link}>Upload</NavLink>}
        {isAdmin && <NavLink to="/policies" className={link}>Attendance Policies</NavLink>}
        {isAdmin && <NavLink to="/admin" className={link}>Administration</NavLink>}
        <div className="spacer" />
        <div className="userbox">
          <div>{name}</div>
          <div>{username}</div>
          <div>{isAdmin ? "Administrator" : "Reader"}</div>
          <button className="ghost" style={{ marginTop: 8 }}
                  onClick={() => instance.logoutRedirect()}>Sign out</button>
        </div>
      </aside>
      <main className="main">
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/executive" element={<Executive />} />
          <Route path="/employees" element={<Employee />} />
          <Route path="/employees/:id" element={<EmployeeProfile />} />
          <Route path="/rankings" element={<Rankings />} />
          <Route path="/locations" element={<Locations />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/upload" element={<AdminRoute><Upload /></AdminRoute>} />
          <Route path="/policies" element={<AdminRoute><AttendancePolicies /></AdminRoute>} />
          <Route path="/admin" element={<AdminRoute><Administration /></AdminRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <>
      <AuthenticatedTemplate><Shell /></AuthenticatedTemplate>
      <UnauthenticatedTemplate><SignIn /></UnauthenticatedTemplate>
    </>
  );
}
